import type { GridApi } from 'ag-grid-community'

import { Artifact } from '@/gen/artifacts/v1/model_pb'

import { AgArtifactTable } from './ag-grid-artifact/ag-artifact-table'

type CompanyArtifactTableProps = {
  isExport?: boolean
  readOnly?: boolean
  autoHeight?: boolean
  data: Artifact[]
  isLoading: boolean
  className?: string
  /** Ignored when `isExport` or `autoHeight` is set. */
  containerClassName: string
  /** Context identifier to scope filters (e.g., 'companyDrawer', 'evidenceCollection') */
  filterContext?: string
  selection?: {
    enabled: boolean
    onSelectionChanged?: (ids: string[]) => void
  }
  onGridReady?: (api: GridApi) => void
}

export const CompanyArtifactTable = ({
  isExport = false,
  readOnly = false,
  autoHeight = false,
  data,
  isLoading,
  className,
  containerClassName,
  filterContext,
  selection,
  onGridReady,
}: CompanyArtifactTableProps) => {
  return (
    <AgArtifactTable
      data={data}
      isLoading={isLoading}
      readOnly={readOnly}
      isExport={isExport}
      autoHeight={autoHeight}
      className={className}
      containerClassName={containerClassName}
      filterContext={filterContext}
      selection={selection}
      onGridReady={onGridReady}
    />
  )
}
